module.exports = __webpack_public_path__ + "media/newstyle/images/icon-donthave-8cd42208c66072ad9c47f3df105ddc93.svg";